import { Application } from "@hotwired/stimulus";
const application = Application.start();
// let application;
// // Check if we already have an application instance
// if (window.StimulusApplication) {
//   application = window.StimulusApplication;
// } else {
//   application = Application.start();
//   window.StimulusApplication = application;
// }

export default application;
